// extracted by mini-css-extract-plugin
export var lightMode = "_o-0";